export enum EXCHANGES {
  NSE = "NSE",
  BSE = "BSE",
}

export enum CHART_PERIOD {
  ONE_WEEK = "w1",
  ONE_MONTH = "m1",
  SIX_MONTH = "m6",
  ONE_YEAR = "y1",
  FIVE_YEAR = "y5",
}

export enum OPTION52WEEk {
  HIGH = "High",
  LOW = "Low",
}

export enum OPTION_GAINER_LOSERS {
  GAINERS = "gain",
  LOSSERS = "lose",
}

export enum MARKET_CAP_TYPE {
  LARGE = "LARGE",
  MID = "MID",
  SMALL = "SMALL",
}
